import { Component } from '@angular/core';
import { DateUtil } from '../../ui/DateUtil';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-form-nullifiednodatetime-field',
  templateUrl: './form-nullifiednodatetime-field.component.html',
  styleUrl: './form-nullifiednodatetime-field.component.scss'
})
export class FormNullifiednodatetimeFieldComponent extends FieldType {

  value = "";

  ngOnInit(): void {
      this.value=DateUtil.getNullifiedNoDateTimeFormat(this.formControl.value);
    }
    
}
